import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { Button, Stack } from '@mui/material';
import { useHasAvailableTenants } from 'probonio-shared-ui/module/me';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNewDialogState } from '../component/dialog/BasicDialog';
import MessageLayout from '../component/layout/MessageLayout';
import { useBikeleasingPortalLinkBuilder } from '../module/bikeleasingV2/bikeleasingPortalLink';
import { SwitchTenantDialog } from '../module/me/SwitchTenantDialog';

const WrongPreferredPortalPage: React.FC = () => {
  const navigate = useNavigate();
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();

  const { t } = useTranslation('errorModule');
  const hasAvailableTenants = useHasAvailableTenants();

  const switchTenantDialog = useNewDialogState();

  const handleRedirect = useCallback(async () => {
    const url = buildBikeleasingPortalLink();
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url });
    } else {
      window.location.href = url;
    }
  }, [buildBikeleasingPortalLink]);

  const handleLogout = useCallback(() => {
    navigate('/logout');
  }, [navigate]);

  return (
    <>
      <MessageLayout title={t('wrongPreferredPortal.header')} text={t('wrongPreferredPortal.text')}>
        <Stack
          spacing={1}
          sx={{
            justifySelf: 'center',
            width: '80%',
          }}
        >
          <Button variant="contained" color="primary" onClick={handleRedirect}>
            {t('wrongPreferredPortal.button')}
          </Button>
          {hasAvailableTenants && (
            <Button variant="outlined" color="primary" onClick={switchTenantDialog.handleOpen}>
              {t('profilePage:switchTenant')}
            </Button>
          )}
          <Button variant="contained" color="secondary" onClick={handleLogout}>
            {t('logout')}
          </Button>
        </Stack>
      </MessageLayout>
      <SwitchTenantDialog dialogState={switchTenantDialog.dialogState} />
    </>
  );
};

export default WrongPreferredPortalPage;
